import { render, staticRenderFns } from "./MeetingSummary.vue?vue&type=template&id=04ed1b6c&"
import script from "./MeetingSummary.vue?vue&type=script&lang=js&"
export * from "./MeetingSummary.vue?vue&type=script&lang=js&"
import style0 from "./MeetingSummary.vue?vue&type=style&index=0&id=04ed1b6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports